var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcInternalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4333 17.9166V2.91663C17.4333 2.22496 16.875 1.66663 16.1833 1.66663H5.51667C5.175 1.66663 4.85833 1.80829 4.63333 2.03329C4.40833 2.25829 4.26667 2.57496 4.26667 2.91663V17.9166H3V19.1666H18.7V17.9166H17.4333ZM11.475 17.9166V15.2H10.225V17.9166H5.51667V2.91663H16.175V17.9166H11.4667H11.475Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29167 11.7583H8.04167V13.425H9.29167V11.7583Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6583 11.7583H12.4083V13.425H13.6583V11.7583Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29167 8.39996H8.04167V10.0666H9.29167V8.39996Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6583 8.39996H12.4083V10.0666H13.6583V8.39996Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29167 5.04996H8.04167V6.71663H9.29167V5.04996Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6583 5.04996H12.4083V6.71663H13.6583V5.04996Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInternalIcon);
export default __webpack_public_path__ + "static/media/ic-internal-icon.96a272a5279878fdcf8484dee6d19251.svg";
export { ForwardRef as ReactComponent };